import { StyleSheet } from 'react-native';
import { alert, neutrals } from 'src/theme/colors';

export const styleShared = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  progress: {
    flex: 1,
    minWidth: '30%',
    minHeight: '30%',
    paddingVertical: 8,
  },
  wrapperHeader: {
    flex: 1,
    paddingVertical: 8,
    alignItems: 'center',
    minHeight: 30,
    minWidth: 300,
  },
  wrapperFooter: {
    flex: 1,
    paddingVertical: 8,
    alignItems: 'center',
  },
  footerText: {
    fontWeight: '400',
    fontSize: 14,
    lineHeight: 21,
  },
  headerText: {
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 21,
  },
  errorInnerWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  errorTitle: {
    fontWeight: 700,
    fontSize: 24,
    lineHeight: 32,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'center',
  },
  errorDescriptionCenter: {
    fontWeight: 400,
    fontSize: 18,
    lineHeight: 27,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'center',
  },
  icon: {
    width: 16,
    height: 16,
  },
  errorTextLink: {
    color: alert.alertRed,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 16,
    borderBottomWidth: 1,
    borderStyle: 'dotted',
    borderColor: alert.alertRed,
  },
  buttonText: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
  },
});

export const stylesDesktop = StyleSheet.create({
  ...styleShared,
  errorWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 16,
    gap: 8,
    width: '30%',
  },
  button: {
    width: 217,
    maxHeight: 50,
  },
});

export const stylesMobile = StyleSheet.create({
  ...styleShared,
  errorWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 16,
    gap: 4,
    width: '90%',
  },
  button: {
    width: 280,
    maxHeight: 60,
  },
});
